import CustomFilterInfo from './CustomFilterInfo';

export default CustomFilterInfo;
